import { Component, ChangeDetectionStrategy } from '@angular/core';
import { HeroComponent } from '../../components/hero/hero.component';
import { LocationMapComponent } from '../../components/location-map/location-map.component';
import { YoutubeFeatureComponent } from '../../components/youtube-feature/youtube-feature.component';
import { SocialLinksComponent } from '../../components/social-links/social-links.component';

@Component({
    selector: 'app-home',
    imports: [HeroComponent, LocationMapComponent, YoutubeFeatureComponent, SocialLinksComponent],
    templateUrl: './home.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./home.component.css']
})
export class HomeComponent {}